<template>
    <div>
        <div v-if="showProductInfo">
            <show-row-col
                :showLabel="
                    $t('com_kaassoort', {
                        ns: 'common'
                    })
                "
                :showObject="localStock.product"
            />
            <show-row-col
                :showLabel="
                    $t('com_number', {
                        ns: 'common'
                    })
                "
                :showObject="localStock.aantal"
            />
        </div>
        <div class="form-inline">
            <b-input-group
                :prepend="
                    $t('com_producttransformation', {
                        ns: 'common'
                    })
                "
            >
                <product-selector
                    v-model="toProduct"
                    v-bind:discrim="localDiscrim"
                    :filter="filterKaas"
                    @input="setChangedProduct"
                />
            </b-input-group>
        </div>
        <b-input-group
            :prepend="
                $t('com_transformfactor', {
                    ns: 'common'
                })
            "
        >
            <b-form-input
                id="input-amount"
                :placeholder="
                    $t('com_amount', {
                        ns: 'common'
                    })
                "
                type="number"
                v-model.number="transformFactor"
                @change="setChangedFactor"
            ></b-form-input>
        </b-input-group>
    </div>
</template>
<script>
import { VoorraadItem } from '../../models/Voorraad';
import DateHelper from '../../models/DateHelper';
import { loadItem, loadList, loadGetItem } from '../../models/DataHelper';
import { PRODCAT_ENUM } from '../../models/ProductCategorie';
import { ProductSelector } from '.';
import { ShowRowCol } from '../components';
export default {
    name: 'StockTransform',
    data: function () {
        return {
            lctypeUnits: window.constants.LCPERUNITS,
            localStock: null,
            isKaas: true,
            transformFactor: 1,
            toProduct: null
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        inStock: {
            type: VoorraadItem,
            required: true
        },
        showProductInfo: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ProductSelector,
        ShowRowCol
    },
    watch: {},
    computed: {
        localDiscrim() {
            if (this.isKaas) return PRODCAT_ENUM.Kaas.toString();
            return '!' + PRODCAT_ENUM.Kaasmerk.toString();
        },
        filterKaas() {
            return this.isKaas ? 'kaas' : '';
        }
    },
    methods: {
        setChangedFactor(value) {
            this.transformFactor = value;
            this.set_input();
        },
        setChangedProduct(value) {
            this.toProduct = value;
            this.set_input();
        },
        set_input() {
            if (this.toProduct != this.localStock.productID) {
                const newProduct = {
                    productID: this.toProduct,
                    multiplier: this.transformFactor
                };
                this.$emit('input', newProduct);
            }
        }
    },
    async mounted() {},
    created() {
        this.localStock = this.inStock;
        this.toProduct = this.localStock.productID;
    }
};
</script>

<style scoped></style>
